import { msg } from 'gt-react';
import { TableIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const RexelFilesPage = lazyRouteComponent(
  () => import('./RexelFilesPage'),
  'RexelFilesPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/rexel-files',
  staticData: {
    app: {
      nav: {
        label: msg('Rexel Files', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <TableIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        order: 35,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: RexelFilesPage,
  validateSearch: z.object({}),
  loader: () => ({
    crumb: msg('Rexel Files', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
  },
});
